/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Help_LinkInputs */

const en_portalsignin_help_link = /** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get help`)
};

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const ar_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const he_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const ur_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const es_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const fr_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const de_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const pt_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const hi_portalsignin_help_link = en_portalsignin_help_link;

/** @type {(inputs: Portalsignin_Help_LinkInputs) => LocalizedString} */
const bn_portalsignin_help_link = en_portalsignin_help_link;

/**
* | output |
* | --- |
* | "Get help" |
*
* @param {Portalsignin_Help_LinkInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_help_link = /** @type {((inputs?: Portalsignin_Help_LinkInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Help_LinkInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_help_link(inputs)
	if (locale === "he") return he_portalsignin_help_link(inputs)
	if (locale === "ur") return ur_portalsignin_help_link(inputs)
	if (locale === "es") return es_portalsignin_help_link(inputs)
	if (locale === "fr") return fr_portalsignin_help_link(inputs)
	if (locale === "de") return de_portalsignin_help_link(inputs)
	if (locale === "pt") return pt_portalsignin_help_link(inputs)
	if (locale === "hi") return hi_portalsignin_help_link(inputs)
	if (locale === "bn") return bn_portalsignin_help_link(inputs)
	return /** @type {LocalizedString} */ ("Get help")
});